module.exports = __webpack_public_path__ + "static/img/IMG_20150610_214645-ANIMATION.a7d0a108.gif";